import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Define a function to generate resource paths
const getResources = (locales: any[], namespaces: any[]) =>
  locales.reduce((resources, locale) => {
    namespaces.forEach((namespace) => {
      resources[locale] = resources[locale] || {};
      resources[locale][namespace] = require(`./assets/locales/${locale}/${namespace}.json`);
    });
    return resources;
  }, {});

const locales = ['en', 'it', 'de', 'nl'];
const namespaces = [
  'general',
  'homepage',
  'userManagement',
  'registration',
  'fixations',
  'orderTracking',
  'tollingAccount',
  'invoice',
  'financialExposure',
  'qualityCertification'
];

export const resources = getResources(locales, namespaces);

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: locales,
  ns: namespaces,
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
  returnEmptyString: true,
});

export default i18n;
